import React, {Component} from 'react';
import {Settings} from "../Utils/Settings";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import Grid from '@material-ui/core/Grid';
import {Helmet} from "react-helmet";
import Typography from "@material-ui/core/es/Typography/Typography";
import Helpers from "../Utils/Helpers";
import Card from '@material-ui/core/Card';
import ResponsiveEmbed from "react-responsive-embed";
import Button from "@material-ui/core/Button";

import {
    FacebookShareButton,
    TwitterShareButton,
    PinterestShareButton,
    EmailShareButton,
} from 'react-share';

import {
    FacebookIcon,
    TwitterIcon,
    PinterestIcon,
    EmailIcon,
} from 'react-share';

import { Link } from "react-router-dom"
import {ReducedButton, SoldButton, PrintButton} from "./Buttons";
import FinancingCalculator from "./FinancingCalculator";

class DetailsCargo extends Component {

    render() {

        const details = this.props.searchDetailsRecord;

        if (!details) {
            return "";
        }

        let images = [];
        let firstImage = "";

        for (var index = 1; index <= 30; index++) {
            let image = details["IMG" + index][0];
            let thumbnail = details["IMGTHUMB" + index][0];
            let caption = details["COM" + index][0];
            if (image && image.length > 0) {
                if (firstImage.length === 0) {
                    firstImage = image;
                }

                images.push({
                    original: image,
                    thumbnail: thumbnail,
                    description: caption
                });
            }
        }

        let normalPrice = parseFloat(details.ct_price[0]).toFixed(0);

        let pageTitle = details.ct_year[0] + " " + details.ct_manu[0] + " " + details.ct_model[0];
        let pageCanonicalUrl = details.URL[0];

        let videoUrl = Helpers.getVideoEmbedUrl(details.ct_videourl[0]);
        let video =(videoUrl) ?
            <ResponsiveEmbed src={videoUrl} allowFullScreen></ResponsiveEmbed> :
            null;

        let trackingImage = "https://dashboard.equinemediaworld.com/Listing/Impression?lt=" + Settings.inventoryTypes.TRAILER + "&id=" + details.ct_id[0];

        let shareUrl = Settings.socialShareUseCanonicalUrls ? pageCanonicalUrl : window.location.href;

        let reducedButton = details.ct_r && details.ct_r[0] === "R" ?
            <React.Fragment><ReducedButton/><br/></React.Fragment> :
            null;

        let soldButton = details.ct_solddate && details.ct_solddate[0].length > 0 ?
            <React.Fragment><SoldButton/><br/></React.Fragment> :
            null;

        return (
            <div>
            <Grid container spacing={24}>
                <Helmet>
                    <title>{pageTitle}</title>
                    <link rel="canonical" href={shareUrl}/>
                    <meta name="og:url" content={shareUrl}/>
                    <meta name="og:image" content={firstImage}/>
                    <meta name="og:type" content="product"/>
                    <meta name="twitter:card" content="summary"/>
    			<meta name="inventory:type" content="cargo" />
    			<meta name="inventory:new" content={details.ct_new[0]} />
    			<meta name="inventory:manu" content={details.ct_manu[0]} />
    			<meta name="inventory:stock" content={details.ct_stock[0]} />
                </Helmet>
                <Grid item xs={12}>
                    <Link style={{textDecoration: "none"}} to="/search/cargo-trailers"><Button style={{marginBottom: "15px"}} variant="contained" color="default">Back</Button></Link>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='h1'>{pageTitle}</Typography>
                </Grid>
                <Grid item sm={9} xs={12}>
                    <ImageGallery items={images}/>
                    {video}
                    <Typography variant='body1' dangerouslySetInnerHTML={{__html: Helpers.safeHtml(details.ct_description[0])}}></Typography>
                    <Typography variant='h6' color='secondary' style={{marginTop: "20px"}} dangerouslySetInnerHTML={{__html: Helpers.safeHtml(details.ct_comment[0])}}></Typography>
                    <img alt="" src={trackingImage} />
                </Grid>
                <Grid item sm={3} xs={12}>
                    <Card style={{padding: "10px"}}>
                        <Typography variant='h5'>${Helpers.formatMoney(normalPrice)}<br/></Typography> {reducedButton}{soldButton}
                        <Typography variant='body2' style={{lineHeight: 2}}>
                            <strong>Mfg:</strong> {details.ct_manu[0]}<br/>
                            <strong>Model:</strong> {details.ct_model[0]}<br/>
                            <strong>Type:</strong> {details.ct_type[0]}<br/>
                            <strong>Year:</strong> {details.ct_year[0]}<br/>
                            <strong>New:</strong> {details.ct_new[0]}<br/>
                            <strong>Pull:</strong> {details.ct_pull}<br/>
                            <strong>Location:</strong> {details.ct_city[0]}, {details.ct_st[0]}<br/>
                            <strong>Stock:</strong> {details.ct_stock[0]}<br/>
                            {details.ct_email[0].length > 0 && <React.Fragment><strong>Email:</strong> <a href={"mailto:" + details.ct_email[0]}>{details.ct_email[0]}</a><br/></React.Fragment>}
                            {details.ct_phone[0].length > 0 && <React.Fragment><strong>Phone:</strong> {details.ct_phone[0]}<br/></React.Fragment>}
                            {details.ct_phonetf[0].length > 0 && <React.Fragment><strong>Toll-Free:</strong> {details.ct_phonetf}<br/></React.Fragment>}
                        </Typography>

                        <FacebookShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><FacebookIcon round size={32} /></FacebookShareButton>
                        <TwitterShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><TwitterIcon round size={32} /></TwitterShareButton>
                        <PinterestShareButton style={{display: "inline-block", marginRight: "10px"}} media={firstImage} url={shareUrl}><PinterestIcon round size={32} /></PinterestShareButton>
                        <EmailShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><EmailIcon round size={32} /></EmailShareButton>

                        <Typography align={"right"}><PrintButton/></Typography>
                        <FinancingCalculator loanAmount={normalPrice} enabled={Settings.showCargoFinanceCalculator}></FinancingCalculator>
                    </Card>
                </Grid>
            </Grid>
            </div>
        )
    }
}

export default (DetailsCargo);


